<template>
  <v-card class="elevation-10" color="grey lighten-5">
    <v-card-title class="pb-1 headline font-weight-light">
      <span v-if="isEdit">Edit</span>
      <span v-else>Add</span> &nbsp;Alternate Id
      <v-spacer></v-spacer>
      <v-btn flat icon color="black" @click="closeForm">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field v-model="currentAltId.key" label="Key" :rules="keyRules" required>
        </v-text-field>
        <v-text-field v-model="currentAltId.value" label="value" :rules="valueRules" required>
        </v-text-field>
        <v-btn @click="closeForm" color="grey lighten-1 white--text">
          Cancel
        </v-btn>
        <v-btn :disabled="!valid" color="primary" @click="saveAltId">
          Save
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import lodash from "lodash"
export default {
  name: "AlternateIdForm",
  props: ["altId"],
  data() {
    return {
      valid: false,
      currentAltId: {
        key: "",
        value: ""
      },
      isEdit: false,
      keyRules: [(v) => !!v || "Key is required"],
      valueRules: [(v) => !!v || "Value is required"]
    }
  },
  methods: {
    /**
     * closeForm - close add / edit alternate id form
     */
    closeForm() {
      this.$emit("event:CloseAltIdForm")
    },

    /**
     * saveAltId - publish edit / add alternate id event
     */
    saveAltId() {
      if (this.$refs.form.validate()) {
        if (this.isEdit) {
          this.$emit("event:EditAltId", this.currentAltId)
        } else {
          this.$emit("event:AddAltId", this.currentAltId)
        }
      }
    }
  },
  mounted() {
    console.log("[AlternateIdForm:mounted] altId", this.altId)
    if (!lodash.isEmpty(this.altId)) {
      this.currentAltId = this.altId
      this.isEdit = true
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/PreIngest/Offers/AlternateIdForm.vue